import { createAsyncThunk } from '@reduxjs/toolkit';
import CalendarService from '@/services/CalendarService';
import ContactsService from '@/services/ContactsService';
import TasksService from '@/services/TasksService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`Tasks/${name}`, async (arg) => {
    const requestArg = arg?.query ?? arg;
    const data = await asyncFunction(requestArg);
    return data;
  });

const getAgents = handler('getAgents', CalendarService.getAgents);

const getProperties = handler('getProperties', CalendarService.getProperties);

const getTaskFilterProperties = handler(
  'getTaskFilterProperties',
  CalendarService.getProperties
);

const getTaskFilterContacts = handler(
  'getTaskFilterContacts',
  ContactsService.getContacts
);

const getTaskFilterAgents = handler(
  'getTaskFilterAgents',
  CalendarService.getAgents
);

const getContacts = handler('getContacts', ContactsService.getContacts);

const createTask = handler('createTask', TasksService.createTask);

const getRightbarTasks = handler(
  'getRightbarTasks',
  TasksService.getRightbarTasks
);

const completeTaskFromRightbar = handler(
  'completeTaskFromRightbar',
  TasksService.editTask
);

const changeTaskStatusFromFilteredTasks = handler(
  'changeTaskStatusFromFilteredTasks',
  TasksService.editTask
);

const changeTaskStatusFromAllTasks = handler(
  'changeTaskStatusFromAllTasks',
  TasksService.editTask
);

const getPaginatedFilteredTasks = handler(
  'getPaginatedFilteredTasks',
  TasksService.getPaginatedTasks
);

const getPaginatedAllTaskSection = createAsyncThunk(
  'Tasks/getPaginatedAllTaskSection',
  async ({ sectionKey, query }) => {
    const response = await TasksService.getPaginatedTasks(query);

    return {
      sectionKey,
      response,
    };
  }
);

const editTask = handler('editTask', TasksService.editTask);

const getAgentConflicts = handler(
  'getAgentConflicts',
  TasksService.getAgentConflicts
);

const getTaskFilterPropertyById = handler(
  'getTaskFilterPropertyById',
  CalendarService.getProperty
);

const getTaskFilterContactById = handler(
  'getTaskFilterContactById',
  ContactsService.getContact
);

export {
  getAgents,
  getProperties,
  getTaskFilterProperties,
  getTaskFilterContacts,
  getTaskFilterPropertyById,
  getTaskFilterContactById,
  getTaskFilterAgents,
  getContacts,
  createTask,
  editTask,
  getRightbarTasks,
  completeTaskFromRightbar,
  changeTaskStatusFromFilteredTasks,
  changeTaskStatusFromAllTasks,
  getPaginatedFilteredTasks,
  getPaginatedAllTaskSection,
  getAgentConflicts,
};
